import { Component, inject } from "@angular/core";
import { OverlayPopupRef, MAT_OVERLAY_DATA, AppSettingsService } from "../../core";
import { IUserInformation } from "./user-information";
import { MessageService } from "../../main";
import { Clipboard } from "@angular/cdk/clipboard";
import { CommonConsants } from "../../features/bucket-items/constants/component-constants";
import { NgClass } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
    selector: "user-information-overlay",
    templateUrl: "./user-information-overlay.component.html",
    styleUrls: ["./user-information-overlay.component.scss"],
    imports: [NgClass, MatIconButton, MatTooltip]
})
export class UserInformationOverlayComponent {
  dialogRef = inject<OverlayPopupRef<UserInformationOverlayComponent>>(OverlayPopupRef);
  private clipboard = inject(Clipboard);
  private messageService = inject(MessageService);
  private appSettingService = inject(AppSettingsService);
  inputData = inject<IUserInformation>(MAT_OVERLAY_DATA);

  userInfo: IUserInformation;
  headerMessage = "Upload in progress, package locked.";
  constructor() {
    const inputData = this.inputData;

    this.userInfo = inputData;
  }
  copyToClipBoard(email: string) {
    this.clipboard.copy(email);
    this.messageService.success(
      CommonConsants.EMAIL_ID_COPIED,
      this.appSettingService.toastrDisplayTime
    );
  }

  public buildUserInfoOverlayId(controlId: string): string {
    return `user-info-overlay-${controlId}`;
  }
}
